import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "folders-list all-sessions" }
const _hoisted_2 = { class: "accordion-length" }
const _hoisted_3 = { class: "folder-items-container" }
const _hoisted_4 = { class: "folders-list" }
const _hoisted_5 = { class: "create-folder" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "input-wrapper" }
const _hoisted_8 = { class: "p-input-icon-right" }
const _hoisted_9 = ["src"]

import { ref, computed } from 'vue';
import ConfirmationModal from './ConfirmationModal.vue';
import RadioButton from 'primevue/radiobutton';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import plusWhite from '@/assets/images/Plus-white.svg';
import { updateSession } from '../services/sessions';
import { Session } from '@/types/session-interfaces';
import CloseCircle from "@/assets/images/CloseCircle.svg";
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'MoveSessionModal',
  emits: [
  'reloadPage'
],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore();

const emit = __emit;

// Template refs
const moveSessionModal = ref<InstanceType<typeof ConfirmationModal> | null>(
  null
);

// State
const moveSessionLocation = ref<string | null>(null);
const showCreateFolderInput = ref(false);
const newFolderName = ref('');
const createFolderLoading = ref(false);

// Computed
const modalHeader = computed(() => {
  const count = selection.value.length;
  return `Move ${count} session${count === 1 ? '' : 's'} to`;
});

const isNewFolderNameValid = computed(
  () => newFolderName.value.trim().length > 0
);

// Methods
const resetCreateFolderState = () => {
  showCreateFolderInput.value = false;
  newFolderName.value = '';
};

const handleSaveFolder = async () => {
  if (!isNewFolderNameValid.value) return;

  createFolderLoading.value = true;
  try {
    const payload = {
        title: newFolderName.value.trim(),
        type: "folder",
    };
    const newFolder = await store.dispatch("itemList/createItem", payload)
    moveSessionLocation.value = newFolder.id;

    resetCreateFolderState();
  } catch (error) {
    console.error('Failed to create folder:', error);
    // TODO: Show user-friendly error message
  } finally {
    createFolderLoading.value = false;
  }
};

const handleCancelFolder = () => {
  resetCreateFolderState();
};

const selection = computed({
  get: () =>  store.getters['itemList/getSelectedItems'],
  set: (val) => store.dispatch('itemList/updateSelection', val),
});

const allFolders = computed(() =>  {
  return store.getters['itemList/getAllFolders']
});

const show = async () => {
  if (!moveSessionModal.value) {
    console.error('Modal reference is not available');
    return false;
  }

  const confirmed = await moveSessionModal.value.show();

  if (confirmed && moveSessionLocation.value) {
    const folderId =
      moveSessionLocation.value === 'allSessions'
        ? null
        : moveSessionLocation.value;
    try {
      await Promise.all(
        selection.value.map((item: Session) =>
          updateSession(item.id, { folderId })
        )
      );
      store.commit("itemList/clearSelection");
      emit('reloadPage');
      moveSessionLocation.value = null;
      return true;
    } catch (error) {
      console.error('Failed to move sessions:', error);
      // TODO: Show user-friendly error message
      return false;
    }
  }
  return false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_AccordionHeader = _resolveComponent("AccordionHeader")!
  const _component_AccordionContent = _resolveComponent("AccordionContent")!
  const _component_AccordionPanel = _resolveComponent("AccordionPanel")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _directive_focustrap = _resolveDirective("focustrap")!

  return (_openBlock(), _createBlock(ConfirmationModal, {
    ref_key: "moveSessionModal",
    ref: moveSessionModal,
    modal: "",
    header: modalHeader.value,
    buttonTextConfirm: "Move",
    buttonTextCancel: "Cancel",
    isVibrantPurple: "",
    smallerTitle: "",
    class: "move-session-modal"
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[8] || (_cache[8] = _createElementVNode("p", null, "All Sessions", -1)),
          _createVNode(_unref(RadioButton), {
            modelValue: moveSessionLocation.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((moveSessionLocation).value = $event)),
            value: "allSessions",
            "aria-label": "Move to All Sessions"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_Accordion, null, {
          default: _withCtx(() => [
            _createVNode(_component_AccordionPanel, null, {
              default: _withCtx(() => [
                _createVNode(_component_AccordionHeader, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "accordion-header" }, " My Folders ", -1)),
                      _createElementVNode("span", _hoisted_2, " (" + _toDisplayString(allFolders.value.length) + ") ", 1)
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allFolders.value, (folder) => {
                    return (_openBlock(), _createBlock(_component_AccordionContent, {
                      key: folder.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("p", null, _toDisplayString(folder.title), 1),
                          _createVNode(_unref(RadioButton), {
                            modelValue: moveSessionLocation.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((moveSessionLocation).value = $event)),
                            value: folder.id,
                            "aria-label": `Move to ${folder.title}`
                          }, null, 8, ["modelValue", "value", "aria-label"])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          (!showCreateFolderInput.value)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                class: "create-folder-button",
                label: "Create new folder",
                variant: "text",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showCreateFolderInput.value = true)),
                onKeydown: _cache[3] || (_cache[3] = ($event) => {
              if ($event.key === 'Enter') {
                $event.preventDefault();
                showCreateFolderInput.value = true;
              }
            }),
                "aria-label": "Create new folder",
                "aria-labelledby": showCreateFolderInput.value ? 'create-folder-input' : ''
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("img", {
                    role: "presentation",
                    src: _unref(plusWhite),
                    alt: "Create new folder",
                    class: "create-folder-icon"
                  }, null, 8, _hoisted_6)
                ]),
                _: 1
              }, 8, ["aria-labelledby"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_unref(InputText), {
                      id: "newFolderName",
                      modelValue: newFolderName.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newFolderName).value = $event)),
                      class: "input",
                      maxlength: "50",
                      onKeydown: _withKeys(handleSaveFolder, ["enter"])
                    }, null, 8, ["modelValue"]),
                    (newFolderName.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          "aria-label": "Clear input",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (newFolderName.value = '')),
                          src: _unref(CloseCircle),
                          alt: "Clear input",
                          class: "clear-icon"
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_unref(Button), {
                  label: "Save",
                  variant: "text",
                  onClick: handleSaveFolder,
                  onKeydown: _cache[6] || (_cache[6] = ($event) => {
              if ($event.key === 'Enter') {
                $event.preventDefault();
                handleSaveFolder();
              }
            }),
                  disabled: !isNewFolderNameValid.value,
                  loading: createFolderLoading.value,
                  "aria-label": "Save",
                  class: "create-folder-save"
                }, null, 8, ["disabled", "loading"]),
                _createVNode(_unref(Button), {
                  autofocus: "",
                  label: "Cancel",
                  variant: "text",
                  onClick: handleCancelFolder,
                  onKeydown: _cache[7] || (_cache[7] = ($event) => {
              if ($event.key === 'Enter') {
                $event.preventDefault();
                handleCancelFolder();
              }
            }),
                  "aria-label": "Cancel",
                  class: "create-folder-cancel"
                })
              ], 64))
        ])
      ])), [
        [_directive_focustrap]
      ])
    ]),
    _: 1
  }, 8, ["header"]))
}
}

})